import { FC } from "react";
import Alert from "../../../../../components/attentions/Alert";
import RawHTML from "../../../../../components/basics/RawHTML";
import { ErrorMessage } from "../../../../../components/forms";

type Props = {
  id: string;
  text: string;
  onValueChange: (value: boolean) => void;
  error?: string | boolean | null;
  checked?: boolean;
};

const AgreeCheckboxSection: FC<Props> = ({ text, onValueChange, id, error, checked }) => {
  return (
    <span>
      <Alert type={error ? "error" : "warning"}>
        <div className="flex">
          <input
            type="checkbox"
            name={id}
            id={id}
            className="peer cursor-pointer relative z-10 w-6 h-6 before:absolute before:inline-block before:border before:rounded-sm before:w-6 before:h-6 before:border-grey-light before:bg-grey-lightest before:transition-all before:duration-200 after:transition-all after:duration-200 icon-check icon-transparent icon-inset-0 after:w-6 after:h-6 checked:icon-3 checked:icon-white checked:before:border-green checked:before:bg-green mr"
            onChange={e => onValueChange(e.target.checked)}
            checked={checked}
          />
          <RawHTML boldedLinks content={text} />
        </div>
      </Alert>
      {error && <ErrorMessage error={error} />}
    </span>
  );
};

export default AgreeCheckboxSection;
